import { combineReducers } from 'redux'
import ekko from './Ekko/reducer'
import appList from './appList/reducer'
import settings from './Settings/reducer'
import admin from './Admin/reducer'
import users from './Users/reducer'
import rooms from './Rooms/reducer'
import messages from './Messages/reducer'
import dashboard from './Dashboard/reducer'
import onboarding from './OnBoardingNow/reducer'
import securityurls from './SecurityUrl/reducer'

export default combineReducers({
    ekko,
    settings,
    admin,
    users,
    rooms,
    messages,
    appList,
    dashboard,
    onboarding,
    securityurls
})
